import { api } from '@config/api';
import { env } from '@config/env';
import type { User } from '../types/User';

export const authService = {
  me: () => api.get<User>('/me').then((r) => r.data),
  logout: () => api.post('/auth/logout').then(() => undefined),
};

/**
 * Inicia o fluxo OIDC redirecionando o navegador ao back (SPEC 1.1 BR-1 / 1.4 BR-1).
 * O front não implementa OIDC: só dispara o redirect. O back troca o code, emite os
 * cookies e redireciona de volta a `/auth/azure/callback?success=1`.
 */
export function startEntraLogin(): void {
  window.location.href = `${env.VITE_API_URL}/auth/entra/login`;
}
